import { render, staticRenderFns } from "./wine-collections-lover.vue?vue&type=template&id=c691330c&scoped=true"
import script from "./wine-collections-lover.vue?vue&type=script&lang=js"
export * from "./wine-collections-lover.vue?vue&type=script&lang=js"
import style0 from "./wine-collections-lover.vue?vue&type=style&index=0&id=c691330c&prod&scoped=true&lang=css"
import style1 from "./wine-collections-lover.vue?vue&type=style&index=1&id=c691330c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c691330c",
  null
  
)

export default component.exports